export default __webpack_public_path__ + "static/media/trash.fd580e41.svg";